<template>
  <v-toolbar-items class="hidden-sm-and-down">
     <v-btn to="/"  text color="primary" dense >الرئيسية</v-btn>
    <v-menu :left="isLeft()" open-on-hover offset-y v-for="category in categories" :key="category.id">
      <template v-slot:activator="{ on, attrs }">
        <v-btn   :to="`/category/${category.outlineId}`"  text color="primary" dense v-bind="attrs" v-on="on">{{category.name | localized}}</v-btn>
      </template>
      <div class="d-flex" v-if="category.subCategories.length > 0">
        <v-list width="200px" class="mx-1" v-for="subCategory in category.subCategories" :key="subCategory.outlineId" flat>
          <v-list-item :to="`/category/${subCategory.outlineId}`">
            <v-list-item-content>
              <v-list-item-title >{{subCategory.name | localized}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item :to="`/category/${leafCategory.outlineId}`"  dense v-for="leafCategory in subCategory.subCategories" :key="leafCategory.id">
            <v-list-item-content>
              <v-list-item-title>{{leafCategory.name | localized}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-menu>
    <v-btn to="/HelpRequest"  text color="primary" dense >المساعدات</v-btn>
  </v-toolbar-items>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CategoriesMenu",

  //********************** */
  data: () => ({
    //
  }),

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      categories: "categories",
    }),
      ...mapGetters("Account", {
      language: "language",
    })
  },
  methods: {
    isLeft: function(){
      return this.language === "ar";
    }
  }


};
</script>

<style >


</style>